import { createSelectDateFilterActions } from './selectDateFilterActions';
import { createSelectDestinationActions } from './selectDestinationActions';

export const selectDestinationActions = createSelectDestinationActions();
export const selectDepartureDateActions = createSelectDateFilterActions();
